import { createApiClient } from "@app/utils/apiClient";

export const appStoreClient = createApiClient("https://itunes.apple.com/");

export const searchAppStore = async (
  { term, media = "software", country = "US", limit = 5 } = {},
  options = {},
) => {
  const response = await appStoreClient.get(
    "search",
    {
      term,
      media,
      country,
      limit,
    },
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to search App Store", { cause: response.data });
  }

  return response.data;
};
